<div class="search-container" appClickOutside (clickOutside)="clearSearchQuery()">
  <div class="search-input-wrapper">
    <input type="text" placeholder="{{ 'Search_digital_card' | translate }}" [(ngModel)]="searchQuery" (input)="search()" class="search-input">
    <div class="search-icon-container" *ngIf="!searching" (click)="search()">
      <mat-icon class="search-icon">search</mat-icon>
    </div>
    <div class="clear-icon" *ngIf="searchQuery" (click)="clearSearchQuery()">
      <mat-icon class="clear-icon">clear</mat-icon>
    </div>
    <div class="search-loader" *ngIf="searching">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
  <div *ngIf="searchResults.length > 0 && !searching" class="search-results">
    <ul>
      <li *ngFor="let userCard of searchResults">
        <a [routerLink]="['/', userCard.cardId]">
          <img [src]="userCard.profilePic ? getUserCardImage(userCard.id, ImageType.PROFILE_PIC) : 'assets/svg/defaultUserIcon.svg'" alt="" class="profile-pic">
          <span class="flexible-user-name">{{ userCard.name }} {{ userCard.surname }}</span>
        </a>
      </li>
      <div *ngIf="!noMoreResults && searchResults.length >= pageSize">
        <button [disabled]="noMoreResults" [ngClass]="{'disabled': noMoreResults}" class="show-more-button"
                (click)="loadMore()">{{ 'search.see_more' | translate }}
        </button>
      </div>
    </ul>
  </div>
  <div *ngIf="searchResults.length === 0 && searchQuery.length >= 2 && !searching" class="no-results">
    {{ 'search.no_results_found' | translate }}
  </div>
</div>
